(function () {
  'use strict';

  if (window.DigAuraProductMedia && window.DigAuraProductMedia.initialized) {
    return;
  }

  var rootSelector = '[data-digaura-media-root]';

  function mountExternalVideo(external) {
    if (!external || external.dataset.digauraMediaLoaded === 'true') {
      return;
    }

    var source = external.getAttribute('data-embed-src');
    var player = external.querySelector('[data-digaura-media-external-player]');
    if (!source || !player) {
      return;
    }

    var provider = external.getAttribute('data-provider') || 'external';
    var providerLabels = { youtube: 'YouTube', vimeo: 'Vimeo', tiktok: 'TikTok' };
    var providerLabel = providerLabels[provider] || provider.charAt(0).toUpperCase() + provider.slice(1);
    var iframe = document.createElement('iframe');
    iframe.src = source;
    iframe.tabIndex = 0;
    iframe.title = providerLabel + ' product video';
    iframe.loading = 'lazy';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    player.appendChild(iframe);

    var cover = external.querySelector('.digaura-product-media__external-cover');
    if (cover) {
      cover.remove();
    }
    external.dataset.digauraMediaLoaded = 'true';
    iframe.focus();
  }

  function initRoot(root) {
    if (!root || root.dataset.digauraMediaBound === 'true') {
      return;
    }

    root.dataset.digauraMediaBound = 'true';
    root.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !(target instanceof Element)) {
        return;
      }

      var trigger = target.closest('[data-digaura-media-external-trigger]');
      if (!trigger || !root.contains(trigger)) {
        return;
      }

      event.preventDefault();
      mountExternalVideo(trigger.closest('[data-digaura-media-external]'));
    });
  }

  function init(context) {
    var scope = context || document;
    if (scope.matches && scope.matches(rootSelector)) {
      initRoot(scope);
    }
    if (scope.querySelectorAll) {
      scope.querySelectorAll(rootSelector).forEach(initRoot);
    }
  }

  window.DigAuraProductMedia = {
    initialized: true,
    init: init
  };

  function initWhenReady() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady, { once: true });
  } else {
    initWhenReady();
  }
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
}());

